<script>
	export let max = 1000000;
	export let colors = [
		'#0C01A3',
		'#EFCB39',
		'#52B4A1',
		'#EF465A',
		'#FC8865',
		'#A4D32E',
		'#7537F2',
		'#5EC0ED',
		'#25BA60',
		'#FED298',
		'#9E1816',
		'#22569B',
		'#027F79',
		'#CF9D06'
	];
	export let values = [0, 0, 9000, 0, 0];
	let items = values.map((value, index) => {
		return {
			value: value,
			color: colors[index]
		};
	});

	let sorted = items.sort((a, b) => a.value - b.value);

	const percentage = (partialValue, totalValue) => {
		return (100 * partialValue) / totalValue;
	};
</script>

<div class="bar-wrapper">
	{#each sorted as val, i}
		<div
			class:visible={percentage(val.value, max) !== 0}
			style="--bg-color: {val.color}; width: {percentage(val.value, max)}%"
		/>
	{/each}
</div>

<style>
	.bar-wrapper {
		--bg-color: #000;
		width: 100%;
		height: 50px;
		border-radius: 4px;
		background-color: #f5f5f7;
		display: flex;
		overflow: hidden;
	}
	.bar-wrapper div {
		background-color: var(--bg-color);
		height: 100%;
		flex-shrink: 0;
	}
	.visible {
		min-width: 1px;
	}
</style>
